// ip-header.interceptor.ts
import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IpService } from '../services/ipAddress.service';

export const IpHeaderInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const ipService = inject(IpService) 
  const ip = ipService.getIp();

    const modifiedReq = req.clone({
      setHeaders: {
        'Client-IP': ip
      }
    });

    return next(modifiedReq);
  }
